








































import vue from 'vue';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import axios from 'axios';
import bus from '@/bus';
import { Currency } from '@MyTelnet/mytelnet-tools-library';
am4core.addLicense('CH197967928');
export default vue.extend({
    name: 'Home',
    data() {
        return {
            months: [
                'January',
                'February',
                'March',
                'April',
                'May',
                'June',
                'July',
                'August',
                'September',
                'October',
                'November',
                'December',
            ],
            currentMonth: '',
            inboundCalls: 0,
            outboundCalls: 0,
            localCalls: 0,
            dialPlanNumber: '',
            extension: '',
            airtimeBalance: 0,
            effectiveCallerId: '',
            avatarURL: '',
            isUserAdmin: false,
        };
    },
    async mounted() {
        await this.getBalance();
        await this.renderDonurt();
        this.currentMonth = this.months[new Date().getMonth()];
        await this.getUserExtension();
        this.getExtensionDialPlan();
        // this.getUserAvatar();
        this.newBalance();
        this.watchCallReports();
    },
    methods: {
        async getBalance() {
            try {
                const res = await axios.get('/voice/account-balance');
                let balance = Math.abs(res.data.postpaid.minLimit) - Math.abs(res.data.postpaid.balance);
                balance = balance + res.data.prepaid.balance;
                this.airtimeBalance = balance;
                this.isUserAdmin = res.data.isadmin;
                bus.$emit('::ISADMIN', res.data.isadmin);
                bus.$emit('::ISDEVELOPER', res.data.developer);
            } catch (e) {
                // alert(JSON.stringify(e));
                bus.$emit('::ISADMIN', false);
                bus.$emit('::ISDEVELOPER', false);
            }
        },
        async newBalance() {
            bus.$on('NEWBALANCE', async () => {
                const res = await axios.get('/voice/account-balance');
                let balance = Math.abs(res.data.postpaid.minLimit) - Math.abs(res.data.postpaid.balance);
                balance = balance + res.data.prepaid.balance;
                this.airtimeBalance = balance;
            });
        },
        async watchCallReports() {
            bus.$on('NEWCALLREPORTS', async () => {
                await this.renderDonurt();
            });
        },
        async renderDonurt() {
            try {
                let result = await this.getInboundOutboundCalls();
                if (result.data) {
                    this.inboundCalls = result.data.inbound;
                    this.outboundCalls = result.data.outbound;
                    this.localCalls = Math.floor(parseInt(result.data.local) / 2);
                } else {
                    this.inboundCalls = 0;
                    this.outboundCalls = 0;
                    this.localCalls = 0;
                }
            } catch (err) {}

            let chart = am4core.create('doughtnut', am4charts.PieChart);
            chart.data = [
                {
                    calls: 'Inbound',
                    numberofCalls: this.inboundCalls,
                },
                {
                    calls: 'Outbound',
                    numberofCalls: this.outboundCalls,
                },
                {
                    calls: 'Internal',
                    numberofCalls: this.localCalls,
                },
            ];

            let pieSeries = chart.series.push(new am4charts.PieSeries());
            pieSeries.dataFields.value = 'numberofCalls';
            pieSeries.dataFields.category = 'calls';
            pieSeries.alignLabels = false;
            pieSeries.labels.template.bent = true;
            pieSeries.labels.template.radius = 3;
            pieSeries.labels.template.padding(0, 0, 0, 0);
            pieSeries.labels.template.text = '{category}: {value.value}';
            pieSeries.slices.template.tooltipText = '{category}: {value.value}';
            pieSeries.ticks.template.disabled = true;

            pieSeries.slices.template.stroke = am4core.color('#fff');
            pieSeries.slices.template.strokeWidth = 2;
            pieSeries.slices.template.strokeOpacity = 1;
            pieSeries.ticks.template.adapter.add('hidden', hideSmall);
            pieSeries.labels.template.adapter.add('hidden', hideSmall);
            function hideSmall(hidden: any, target: any) {
                return target.dataItem.values.value.percent === 0;
            }

            // This creates initial animation
            pieSeries.hiddenState.properties.opacity = 1;
            pieSeries.hiddenState.properties.endAngle = -90;
            pieSeries.hiddenState.properties.startAngle = -90;
        },

        async getInboundOutboundCalls() {
            return axios.get('/voice/inboundcalls');
        },

        async getExtensionDialPlan() {
            if (this.getlocatStorageToken()) {
                const dialPlan = await (this as any).$http.get(`/extension/dial-plan`);
                if (dialPlan.data) {
                    this.dialPlanNumber = dialPlan.data.dialplan_number;
                }
            } else {
                bus.$on(':tokenReceived', async () => {
                    const dialPlan = await (this as any).$http.get(`/extension/dial-plan`);
                    if (dialPlan.data) {
                        this.dialPlanNumber = dialPlan.data.dialplan_number;
                    }
                });
            }
        },

        async getUserExtension() {
            try {
                const userExtension = await (this as any).$http.get(`/extension`);
                if (userExtension.data) {
                    this.extension = userExtension.data.extension;
                    this.effectiveCallerId = userExtension.data.effective_caller_id_name;
                    if (!this.dialPlanNumber) {
                        this.dialPlanNumber = userExtension.data.outbound_caller_id_number;
                    }
                }
            } catch (e) {
                console.error(e);
            }
        },

        async getUserAvatar() {
            try {
                const avatarResult = await axios.get('/user/avatar');
                this.avatarURL = avatarResult.data.avatar;
            } catch (e) {
                console.error(e);
            }
        },

        getlocatStorageToken() {
            const _token = localStorage.getItem('app:ACCESS_TOKEN');
            if (!_token) {
                return undefined;
            }
            return _token;
        },

        formatCurrency(amount: number | string, decimalPlaces?: number, symbol?: string | boolean): string {
            decimalPlaces = decimalPlaces ? 2 : Math.abs(decimalPlaces as number);
            let decimalFormatter: string = '.';
            let thousandsFormatter = ' ';
            amount = this.formatNumber(amount, decimalPlaces, decimalFormatter, thousandsFormatter, symbol);
            let negative = amount < 0 ? '-' : '';
            let numberValueSplit = `${amount}.0`.split('.');
            let decimalValue = '';
            if (decimalPlaces > 0) {
                decimalValue =
                    decimalFormatter + numberValueSplit[1] + '0'.repeat(decimalPlaces - numberValueSplit[1].length);
            }
            return (
                symbol + ' ' + numberValueSplit[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandsFormatter) + decimalValue
            );
        },
        formatNumber(
            amount: number | string,
            decimalPlaces?: number,
            decimalFormatter?: string,
            thousandsFormatter?: string,
            symbol?: string | boolean,
        ): number {
            decimalPlaces = decimalPlaces ? 2 : Math.abs(decimalPlaces as number);
            decimalFormatter = decimalFormatter ? '.' : decimalFormatter;
            thousandsFormatter = thousandsFormatter ? ' ' : thousandsFormatter;
            amount = Number.parseFloat(amount.toString());
            amount = this.toFixed(amount, decimalPlaces);
            return Number.parseFloat(amount.toString());
        },
        toFixed(num: number, precision: number): number {
            const firstFix = Math.round(+(num + 'e' + precision));
            const secondFix = +(firstFix + 'e' + -precision);
            return Number.parseFloat(secondFix.toFixed(precision));
        },
    },
});
